import { styles as cellComponentStyles } from './datepicker-calendar-cell.scss';
import { styles as calendarComponentStyles } from './datepicker-calendar.scss';

import { unsafeCSS } from 'lit';

export const cellStyles = [unsafeCSS(`${cellComponentStyles}`)];
export const calendarStyles = [unsafeCSS(`${calendarComponentStyles}`)];
